import Analytics from 'analytics';
import segmentPlugin from '@analytics/segment';
import googleAnalytics from '@analytics/google-analytics';

const plugins = [];

// Only add Segment if writeKey is configured
if (import.meta.env.VITE_SEGMENT_WRITE_KEY) {
  plugins.push(
    segmentPlugin({
      writeKey: import.meta.env.VITE_SEGMENT_WRITE_KEY as string,
    })
  );
}

// Only add Google Analytics if measurement ID is configured
if (import.meta.env.VITE_GOOGLE_ANALYTICS_MEASUREMENT_ID) {
  plugins.push(
    googleAnalytics({
      measurementIds: [import.meta.env.VITE_GOOGLE_ANALYTICS_MEASUREMENT_ID as string],
    })
  );
}

export const analytics = Analytics({
  app: 'data-mind',
  plugins,
});
